import React from "react";
import {
  BarChart,
  Bar,
  Rectangle,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const MONTH_NAMES = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

function OutAndInpatientGraph({ propdata }) {
  const formattedData = getFormattedData(propdata);

  function getFormattedData(data) {
    if (!Array.isArray(data)) return [];

    const filledData = Array.from({ length: 12 }, (_, i) => {
      const existing = data.find(item => item.month === i + 1);

      return {
        name: MONTH_NAMES[i],
        OutPatients: existing?.outPatient || 0,
        InPatients: existing?.inPatient || 0,
      };
    });

    return filledData;
  }

  return (
    <div className="w-100 container graph">
      <div className="w-100 flex flex-v-center space-between border-bottom p-b-20">
        <div className="bold-text">Outpatient vs Inpatient</div>
      </div>
      <div className="w-100 flex">
        <ResponsiveContainer width="100%" height={300}>
          <BarChart
            data={formattedData}
            margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
          >
            <CartesianGrid vertical={false} strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar
              barSize={10}
              dataKey="OutPatients"
              fill="#3BFF43"
              activeShape={<Rectangle fill="pink" stroke="blue" />}
              name="Outpatients"
            />
            <Bar
              barSize={10}
              dataKey="InPatients"
              fill="#109615"
              activeShape={<Rectangle fill="gold" stroke="purple" />}
              name="Inpatients"
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default OutAndInpatientGraph;
